import PageTitle from '../../components/common/PageTitle'

export const PolicyPageWrapper = ({ title, children }) => (
  <div className="main-container">
    <PageTitle>{title}</PageTitle>
    <p className="text-sm text-gray-500 mb-6">Effective Date: May 20, 2025</p>
    <div className="prose prose-lg text-gray-700">{children}</div>
  </div>
)
